import { render, staticRenderFns } from "./UpdateUserEmailModal.vue?vue&type=template&id=56aa1536&"
import script from "./UpdateUserEmailModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports